import {
  createContext,
  useContext,
  useMemo,
  type PropsWithChildren,
} from 'react';
import type { UnknownObject } from '../types';
import { useSetScreenName } from '../hooks/useSetScreenName';

export type AnalyticsContextValue = {
  screen?: string;
  defaultAnalytics?: UnknownObject;
  defaultAblyOnlyLog?: UnknownObject;
};

type AnalyticsProviderProps = PropsWithChildren<{
  screen: string;
  defaultAnalytics?: UnknownObject;
  defaultAblyOnlyLog?: UnknownObject;
}>;

const AnalyticsContext = createContext<AnalyticsContextValue>({});

export const AnalyticsProvider = ({
  screen,
  defaultAnalytics,
  defaultAblyOnlyLog,
  children,
}: AnalyticsProviderProps) => {
  useSetScreenName(screen);

  const value = useMemo(
    () => ({ screen, defaultAnalytics, defaultAblyOnlyLog }),
    [screen, defaultAnalytics, defaultAblyOnlyLog],
  );

  return (
    <AnalyticsContext.Provider value={value}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = (): AnalyticsContextValue =>
  useContext(AnalyticsContext);
